import { ReactNode, ComponentType } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider as ReduxProvider } from 'react-redux';

import { ErrorBoundary } from './ErrorBoundary';
import { AdobeTargetProvider } from './AdobeTargetProvider';
import { store } from '../../state/store';
import { Contexts } from './Contexts';

type ProvidersProps = {
  LDProvider?: ComponentType<{ children: ReactNode }>;
  children: ReactNode;
};

export const Providers = ({
  LDProvider = ({ children }) => children,
  children
}: ProvidersProps) => {
  return (
    <ErrorBoundary>
      <LDProvider>
        <ReduxProvider store={store}>
          <AdobeTargetProvider>
            <BrowserRouter basename={import.meta.env.VITE_PATH_PREFIX}>
              <Contexts>{children}</Contexts>
            </BrowserRouter>
          </AdobeTargetProvider>
        </ReduxProvider>
      </LDProvider>
    </ErrorBoundary>
  );
};
